export default [
    {
        path: "ip-bundle-lists",
        name: "ipbundlelists",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipBundle/IpBundleList.vue"
            ),
        meta: {
            title: `VPN Node Bundles list`,
        },
    },
    {
        path: "add-ip-bundle",
        name: "addipbundle",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipBundle/AddIpBundle.vue"
            ),
        meta: {
            title: `Add New Node Bundle`,
        },
    },
    {
        path: "edit-ip-bundle/:id",
        name: "editipbundle",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipBundle/AddIpBundle.vue"
            ),
        meta: {
            title: `Edit Node Bundle`,
        },
    },
    {
        path: "ip-bundle-details-lists/:id",
        name: "IpBundleDtlsLists",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/ipBundle/IpBundleDtlsList.vue"
            ),
        meta: {
            title: `Node Bundle Details list`,
        },
    }
];
